import { getCurrentRoute } from '#utils/routes';
import { DEFAULT_ROUTE_PATH, ROUTES } from '#constants/routes';
import { ROLES } from '#constants/users';

import { hasAccess } from './session';

const getLoginPath = (pathname, search) => {
  const searchQueryParam = search ? `&${search.substring(1)}` : '';
  return {
    pathname: ROUTES.LOGIN.path,
    search: pathname === '/' ? '' : `?redirectTo=${pathname}${searchQueryParam}`
  };
};

export const mapRedirects = (tokenManager, pathname, search) => {
  const defaultPath = DEFAULT_ROUTE_PATH[tokenManager?.role];
  const login = getLoginPath(pathname, search);

  return { login, defaultPath };
};

// Without a valid free trial or subscription only the routes flagged availableWithoutAccess can be used (the
// blocking modal is shown instead; routes with hasPremiumGate keep their own PremiumFeatureGate). The backend decides it with workspace.hasValidAccess.
export const isBlockedWithoutAccess = ({ route, currentUser, currentWorkspace }) =>
  !!route &&
  !!currentUser?.workspace &&
  !route.publicRoute &&
  !route.availableWithoutAccess &&
  !route.hasPremiumGate &&
  currentWorkspace?.hasValidAccess === false;

// Landing page after dismissing the blocking modal: owners and admins can subscribe from the workspace configuration
export const getNoAccessPath = role =>
  [ROLES.OWNER, ROLES.ADMIN].includes(role) ? ROUTES.WORKSPACE_CONFIGURATION.path : ROUTES.WORKSPACE.path;

// eslint-disable-next-line complexity
export const getLoggedUserRedirect = ({
  privateRoute,
  access,
  defaultPath,
  didOnboarding,
  needsOnboarding,
  workspace
}) =>
  (needsOnboarding && !workspace && ROUTES.LAWYER_ONBOARDING.path) ||
  (needsOnboarding && !didOnboarding && ROUTES.LAWYER_ONBOARDING.path) ||
  (workspace && !(privateRoute && access) && defaultPath);

const hasDoneOnboarding = user => !user || !!user?.didOnboarding;
const hasWorkspace = user => !user || !!user?.workspace;

const getRedirect = ({
  logged,
  login,
  privateRoute,
  access,
  defaultPath,
  needsOnboarding,
  didOnboarding,
  publicRoute,
  workspace
}) =>
  logged
    ? getLoggedUserRedirect({
        privateRoute,
        access,
        defaultPath,
        needsOnboarding,
        didOnboarding,
        workspace
      })
    : !publicRoute && login;

export const getCurrentRouteRedirect = ({ tokenManager, pathname, search, currentUser }) => {
  const {
    supportedRoles = [],
    publicRoute,
    privateRoute = !publicRoute,
    needsOnboarding = true,
    noRedirect
  } = getCurrentRoute(pathname) || {};

  const logged = !!tokenManager;
  const didOnboarding = hasDoneOnboarding(currentUser);
  const access = publicRoute || hasAccess(tokenManager, supportedRoles, didOnboarding, pathname);

  const { login, defaultPath } = mapRedirects(tokenManager, pathname, search);

  return (
    !noRedirect &&
    getRedirect({
      logged,
      login,
      privateRoute,
      access,
      defaultPath,
      needsOnboarding,
      didOnboarding,
      publicRoute,
      workspace: hasWorkspace(currentUser)
    })
  );
};
